import { useEffect, useRef } from 'react';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

const ImageViewer = ({ imageUrls, alt }) => {
	const viewerRef = useRef(null);

	useEffect(() => {
		const viewer = new Viewer(viewerRef.current);

		return () => {
			viewer.destroy();
		};
	}, [imageUrls]);

	return (
		<div className='vehicle-img-details' ref={viewerRef}>
			{imageUrls.map((image, index) => (
				<div className='single' key={image?.name ? image?.name : image}>
					<img key={index} src={image?.name ? image?.name : image} alt={`${alt} ${index + 1}`} />
				</div>
			))}
		</div>
	);
};

export default ImageViewer;
